import React from 'react';
import {observer} from 'mobx-react';
import {Scrollbar} from '@priority-software/priority-style-react';
import DraggableList, {InjectedDraggableProps} from '../../../components/Common/DraggableList';
import {Filter} from '../stores/Filter';
import {FilterBox} from './FilterBox';
import {AddField} from './AddField';

type Props = {
    selectedSearch: any;
    currentForm: any;
    onDropdownClose: () => void;
    children?: React.ReactNode;
    autoFocus?: boolean;
};

export const FiltersList = observer(
    ({selectedSearch, currentForm, onDropdownClose, children, autoFocus}: Props) => {
        const {filterValues} = selectedSearch;
        const visibleFilterValues = currentForm.isRecon
            ? filterValues.filter(
                  v => v.column.name.startsWith('FRST_') || v.column.name.startsWith('SCND_')
              )
            : filterValues;
        return (
            <Scrollbar componentClasses="filters-list">
                {visibleFilterValues.length > 0 && (
                    <DraggableList
                        keyExtractor={(item: Filter) => item.field + item?.search.name}
                        handleDNDFinish={selectedSearch.setReorderedFilters}
                        data={visibleFilterValues}
                        renderItem={({item, ...props}) => {
                            const draggableItemProps = {
                                ...(props as InjectedDraggableProps),
                                componentClasses: 'search-gen-draggable-item'
                            };
                            return (
                                <FilterBox
                                    fullDisplay
                                    draggable
                                    filter={item}
                                    onClose={onDropdownClose}
                                    {...draggableItemProps}
                                    key={item.field}
                                />
                            );
                        }}
                    />
                )}

                <AddField
                    selectedSearch={selectedSearch}
                    currentForm={currentForm}
                    autoFocus={autoFocus}
                />

                {children}
            </Scrollbar>
        );
    }
);
